package gr.tech.GRAttestation.pages.admin

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import gr.tech.GRAttestation.components.layouts.AdminPageLayout
import gr.tech.GRAttestation.components.widgets.AlertManager
import gr.tech.GRAttestation.components.widgets.UserAlert
import gr.tech.GRAttestation.infrastructure.api.adminFetchFormsSummary
import gr.tech.GRAttestation.infrastructure.api.adminFetchStoreActivitySummary
import gr.tech.GRAttestation.models.activity.ActivityDTO
import gr.tech.GRAttestation.models.attestation.AttestationDTO
import gr.tech.GRAttestation.models.user.USER_ROLES
import gr.tech.GRAttestation.sections.tables.AdminAttestationsSummaryTable
import gr.tech.GRAttestation.sections.tables.AdminStoreSummaryTable
import gr.tech.GRAttestation.styles.admin.AdminSummaryBoxStyle
import gr.tech.GRAttestation.styles.admin.AdminSummaryTitleStyle
import gr.tech.GRAttestation.styles.grstyles.Theme
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Text

/*
    Index page of the Admin Panel
*/
@Page
@Composable
fun AdminDashboardPage() {
    AdminPageLayout(
        title = "Admin Dashboard",
        requiredRoles = listOf(USER_ROLES.CONFIRMED_USER.role)
    ) {ctx ->
        AdminHomeScreen(ctx)
    }
}

@Composable
fun AdminHomeScreen(context: PageContext) {
    val scope = rememberCoroutineScope()
    val breakpoint = rememberBreakpoint()

    // Alerts
    val alertManager = remember { AlertManager() }
    alertManager.DisplayAlerts()

    // Attestation Forms Summary Data
    val attestations = remember { mutableStateListOf<AttestationDTO>() }
    val stores = remember { mutableStateListOf<ActivityDTO>() }

    LaunchedEffect(Unit) {
        // Pulling recent forms, NOT THERE activity
        adminFetchFormsSummary(
            onResponse = { response ->
                if (response.success && response.data != null) {
                    attestations.clear()
                    attestations.addAll(response.data)
                } else {
                    alertManager.addAlert(UserAlert(message = "Error loading activity!", status = 0))
                }
            },
            onError = {}
        )

        // Pulling recent store activity
        adminFetchStoreActivitySummary(
            onResponse = { response ->
                if (response.success && response.data != null) {
                    stores.clear()
                    stores.addAll(response.data)
                } else {
                    alertManager.addAlert(UserAlert(message = "Error loading activity!", status = 0))
                }
            },
            onError = {}
        )
    }

    Column(
        modifier = Modifier
            .padding(24.px)
            .backgroundColor(Theme.HalfWhite.rgb)
            .fillMaxSize()
    ) {
        Column(
            modifier = AdminSummaryBoxStyle.toModifier()
                .margin(bottom = 2.cssRem)
        ) {
            H1(AdminSummaryTitleStyle.toAttrs()) {
                Text("Latest Submissions")
            }
            AdminAttestationsSummaryTable(attestations = attestations)
        }

        Column(
            modifier = AdminSummaryBoxStyle.toModifier()
        ) {
            H1(AdminSummaryTitleStyle.toAttrs()) {
                Text("Latest Store Activity")
            }
            AdminStoreSummaryTable(activities = stores)
        }
    }
}